export default __webpack_public_path__ + "static/media/logo.a09c39af.jpg";